/* ============================================================
   LE STUDIO RUGIER : mode mobile plein écran (« une étape = un écran »)
   ------------------------------------------------------------
   Greffe sur assets/rugier-studio.js SANS le modifier : ce script classique (defer,
   chargé juste après) enveloppe des fonctions globales du configurateur et DÉPLACE
   les nœuds utiles dans une coquille #rmApp (position:fixed). À la sortie, chaque nœud
   revient à la place de son commentaire repère « rm:<id> ».

   Activation : (max-width:900px) and (pointer:coarse), ou ?mobileapp=1 (banc).
   Coupure : ?classique=1, case « Configurateur mobile plein écran » décochée
   (window.RUGIER_MOBILE_APP=false), CSS absent (sentinelle --rm-css) ou fonction
   attendue absente (garde NEED) : l'ancien flux mobile reste.

   Les `let` globaux du configurateur (currentDesign, currentSize, wizSteps, wizIdx,
   wizBranch, chooseMode, isCreateMode, editorState, DESIGNS, feedList…) sont lus et
   écrits par leur NOM NU, jamais via window.

   Lots : L1 coquille/activation/entrée-sortie/rendu du tapis (socle) ; L2 rails Design,
   Import, Taille, Coloris, synchronisation et barre basse (+ socle des feuilles) ; L3 rails
   Composer Design et Outils (gammes, bordure), feuilles complètes, Devis compact, clavier ;
   L4 nuancier ARS plein écran (rmOpenPicker/rmClosePicker, pipette), feuille Plus
   (rmBuildMore), Chez vous (rmAr + recopie de #arBtn).
   ============================================================ */
(function(){ 'use strict';
const Q=new URLSearchParams(location.search);
const DE=document.documentElement;
const rmBootOff=()=>DE.classList.remove('rm-boot');
if(window.RUGIER_MOBILE_APP===false||Q.get('classique')==='1'){ rmBootOff(); return; }

// ── Garde : tout ce que la greffe appelle ou enveloppe doit exister en global ──
const NEED=['startWizard','wizShowHome','wizRender','wizNextStep','wizBackStep','scrollStepIntoView','renderMobilePreview','renderEditorCanvas','updateOrderRecap','updateHistBtns','updateSituBtn','openArsPicker','applySnapshot','enterCreateMode','exitCreateMode','renderDesignGrid','renderPaletteList','renderSizePills','renderCollFilter','selectDesign','renderStage','priceFor','countTintsOf','zonesForQuote','historyGo','shareDesign','downloadJpeg','situOpen','arOpen','buildShareUrl','closeArsInline','arsTraysHtml','arsNearest','arsSnap','pickHexAt','colDist','hexToHsl','generateRandomGeometry','randomComboPalette','genAnchors','editorSnapshot','pushEditorHistory','renderEditorToolbox','sortByLight','loadDesign','framedThumb','recolorSvg','isFreeSize','openCfgAuth','authUser','T'];
if(NEED.some(n=>typeof window[n]!=='function')){ rmBootOff(); return; }
// Les `let` globaux (typeof ne lève pas d'erreur si la liaison n'existe pas).
if(typeof wizSteps==='undefined'||typeof wizIdx==='undefined'||typeof wizBranch==='undefined'||typeof currentDesign==='undefined'
  ||typeof currentSize==='undefined'||typeof chooseMode==='undefined'||typeof isCreateMode==='undefined'||typeof editorState==='undefined'
  ||typeof DESIGNS==='undefined'||typeof WIZ_LABELS==='undefined'||typeof _lastScrollStep==='undefined'){ rmBootOff(); return; }

// Portrait ≤ 900 px, ou paysage bas des grands téléphones (Plus/Pro Max 932x430, Android 915x412) :
// même requête dans le CSS (@media), l'attribut media du <link> et le script rm-boot de la section.
const RM_MQ='(max-width:900px) and (pointer:coarse), (pointer:coarse) and (orientation:landscape) and (max-height:500px)';
const MQ=window.matchMedia?matchMedia(RM_MQ):{matches:false};
const FORCE=Q.get('mobileapp')==='1';
window.RSM_READY=true;

const $=id=>document.getElementById(id);
const body=document.body;
const SECTIONS=['designSection','sizeSection','createDesignSection','editorSection','colorSection','finishSection','saveSection','feedSection'];
const ARIA_HIDE=['.two-col','#homeMarquee','#adminToggle'];

// ── État du module ──
let rmBuilt=false;
let rmRO=null;                 // ResizeObserver de #rmFit
const rmMarks=new Map();       // id → {node, mark} (commentaire repère)
const rmAria=new Map();        // élément → ancienne valeur d'aria-hidden (null = absente)
let rmIgnorePop=false, rmIgnoreTimer=null;
// Sentinelle d'historique suivie ici et pas seulement par history.state : une app tierce du
// thème (script adsagentclient…azurefd.net) rappelle history.replaceState(null,…) juste après
// chaque pushState et efface {rm:1}. L'entrée, elle, reste bien dans la pile.
let rmSentinel=false;
let rmFromPop=false;
let rmFreshCreate=false;       // entrée Composer par la cartouche : composition générée
let rmAutoGenSnap=null;        // editorSnapshot() juste après la génération automatique
let rmLastKey=null;            // wizBranch|étape : change → feuilles et nuancier refermés
const rmEls={};                // nœuds injectés (créés une fois)

const rmOn=()=>body.classList.contains('rm-app');
const cssReady=()=>getComputedStyle(DE).getPropertyValue('--rm-css').trim()==='1';
const rmWanted=()=>(MQ.matches||FORCE)&&body.classList.contains('wiz-on')&&cssReady();
function rmApply(){
  const w=rmWanted(), on=rmOn();
  if(w&&!on) rmEnter();
  else if(!w&&on) rmExit();
}
const rmWarn=e=>{ try{ console.error('[rugier-studio-mobile]', e); }catch(_){} };

// ── Icônes (SVG inline, trait 1,6) ──
const ICON={
  back:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
  undo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 7L5 11l4 4"/><path d="M5 11h9a5 5 0 0 1 0 10h-3"/></svg>',
  more:'<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="1.7"/><circle cx="12" cy="12" r="1.7"/><circle cx="19" cy="12" r="1.7"/></svg>'
};
const esc=s=>String(s==null?'':s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

/* ============================================================
   rmBuild() : coquille #rmApp, une seule fois
   ============================================================ */
function rmBuild(){
  if(rmBuilt) return $('rmApp');
  const app=$('rugierStudioApp'); if(!app) return null;
  const el=document.createElement('div');
  el.id='rmApp'; el.hidden=true;
  el.innerHTML=
    '<div id="rmTop">'+
      '<button type="button" class="rm-ic" id="rmBack" aria-label="'+esc(T('Retour'))+'">'+ICON.back+'</button>'+
      '<div class="rm-title"><span id="rmTitle"></span><span id="rmSub"></span></div>'+
      '<button type="button" class="rm-ic" id="rmUndo" aria-label="'+esc(T('Revenir en arrière'))+'" title="'+esc(T('Revenir en arrière'))+'" disabled>'+ICON.undo+'</button>'+
      '<button type="button" class="rm-ic" id="rmMoreBtn" aria-label="'+esc(T('Plus'))+'" title="'+esc(T('Plus'))+'">'+ICON.more+'</button>'+
      '<button type="button" id="rmQuit">'+esc(T('Quitter'))+'</button>'+
    '</div>'+
    '<div id="rmProg"></div>'+
    '<div id="rmStageSlot"></div>'+
    '<div id="rmPanel">'+
      // Rail de l'étape : en-tête + cartes/puces (rmRenderRail)
      '<div id="rmRail"><div class="rm-rail-head"></div><div class="rm-scroller" id="rmScroller"></div></div>'+
      // Feuilles : les sections du configurateur y sont déplacées à l'entrée
      '<div id="rmSheetBody"></div>'+
      // Feuille « Plus » : lignes construites à chaque ouverture (rmBuildMore)
      '<div id="rmMore"></div>'+
      // Nuancier ARS plein écran : onglets + grille (rmOpenPicker)
      '<div id="rmPicker"><div class="rm-tabs" id="rmPickTabs"></div><div id="rmPickGrid"></div></div>'+
    '</div>'+
    '<div id="rmBar">'+
      // Barre basse : prix + bouton principal (rmSyncBar) ; Annuler/Valider du nuancier
      '<div class="rm-price"><span id="rmPriceLbl"></span><span id="rmPrice"></span></div>'+
      '<button type="button" class="btn" id="rmPrimary" hidden></button>'+
      '<button type="button" class="btn btn-out" id="rmPickCancel">'+esc(T('Annuler'))+'</button>'+
      '<button type="button" class="btn" id="rmPickOk">'+esc(T('Valider'))+'</button>'+
    '</div>';
  app.appendChild(el);

  // Nœuds injectés dans les éléments déplacés (insérés à l'entrée, retirés à la sortie)
  const mk=(tag,props,html)=>{ const n=document.createElement(tag); Object.assign(n,props||{}); if(html!=null) n.innerHTML=html; return n; };
  rmEls.fit=mk('div',{id:'rmFit'});
  rmEls.ph=mk('div',{className:'rm-ph'},'<span class="rm-ph-frame"></span>');
  rmEls.acts=mk('div',{id:'rmStageActions'});
  rmEls.situ=mk('button',{type:'button',id:'rmSitu',className:'btn btn-out',textContent:T('En situation')});
  rmEls.ar=mk('button',{type:'button',id:'rmAr',className:'btn btn-out',textContent:T('Chez vous (AR)')});
  rmEls.acts.appendChild(rmEls.situ); rmEls.acts.appendChild(rmEls.ar);
  rmEls.devisNote=mk('p',{className:'rm-devis-note',textContent:T("Rien n'est commandé ni payé à ce stade.")});
  rmEls.recapLink=mk('button',{type:'button',className:'rm-recap-link',textContent:T('Voir le récapitulatif ›')});
  rmEls.toolNote=mk('p',{className:'rm-note',textContent:T('Le placement libre des formes se fait sur ordinateur.')});

  // Branchements de la barre haute et des actions du tapis
  $('rmBack').addEventListener('click',rmBackAction);
  $('rmUndo').addEventListener('click',()=>{ historyGo(-1); });
  $('rmMoreBtn').addEventListener('click',()=>rmOpenSheet('more'));
  $('rmQuit').addEventListener('click',()=>rmQuit());
  rmEls.situ.addEventListener('click',()=>{ situOpen(); });
  rmEls.ar.addEventListener('click',()=>{ rmAr(); });
  rmEls.recapLink.addEventListener('click',()=>rmOpenSheet('step'));
  $('rmPrimary').addEventListener('click',rmPrimaryClick);

  // Nuancier (lot L4) : Annuler / Valider, onglets et cases par délégation (clic seul), pipette
  $('rmPickCancel').addEventListener('click',()=>rmClosePicker(false));
  $('rmPickOk').addEventListener('click',()=>rmClosePicker(true));
  $('rmPickTabs').addEventListener('click',e=>{ const b=e.target.closest&&e.target.closest('[data-tab]'); if(b&&rmPick&&b.dataset.tab!==rmPick.tab) rmPickRender(b.dataset.tab); });
  $('rmPickGrid').addEventListener('click',e=>{ const b=e.target.closest&&e.target.closest('[data-code]'); if(b&&rmPick) rmPickSelect(b.dataset.code); });
  { const ms=$('mobileStage'); if(ms) ms.addEventListener('click',rmPickPipette); }
  rmArWatch();

  rmBuilt=true;
  return el;
}

/* ============================================================
   rmEnter() / rmExit() / rmQuit()
   ============================================================ */
function rmMove(id,target){
  const n=$(id); if(!n||!n.parentNode||rmMarks.has(id)) return;
  const mark=document.createComment('rm:'+id);
  n.parentNode.insertBefore(mark,n);
  rmMarks.set(id,{node:n,mark});
  target.appendChild(n);
}

function rmEnter(){
  if(rmOn()) return;
  const root=rmBuild(); if(!root) return;
  const mp=$('mobilePreview'), ms=$('mobileStage');
  const inner=mp&&mp.querySelector('.mobile-preview-inner');
  if(!mp||!ms||!inner) return;

  // 1-2) Déplacements (commentaire repère avant chaque nœud)
  rmMove('wizSteps',$('rmProg'));
  rmMove('mobilePreview',$('rmStageSlot'));
  const sb=$('rmSheetBody');
  SECTIONS.forEach(id=>rmMove(id,sb));
  // Textes d'origine des sections : tiret cadratin et glyphes d'icône retirés (rendus à la sortie)
  SECTIONS.forEach(id=>rmDashFix($(id)));

  // 3) Injections
  inner.insertBefore(rmEls.fit,ms); rmEls.fit.appendChild(ms);
  inner.appendChild(rmEls.ph);
  inner.appendChild(rmEls.acts);
  const rc=document.querySelector('#orderSection .recap-card');
  if(rc){ rc.appendChild(rmEls.devisNote); rc.appendChild(rmEls.recapLink); }
  const tb=$('editorToolbox');
  if(tb) tb.insertBefore(rmEls.toolNote,tb.firstChild);

  // 4) Classes et accessibilité
  root.hidden=false;
  body.classList.add('rm-app');
  DE.classList.add('rm-lock');
  ARIA_HIDE.forEach(sel=>{ const e=document.querySelector(sel); if(e&&!rmAria.has(e)){ rmAria.set(e,e.getAttribute('aria-hidden')); e.setAttribute('aria-hidden','true'); } });

  // 5) Entrée d'historique « sentinelle » : le retour navigateur reste dans le Studio
  rmPushSentinel();

  // 6) Rendu
  rmLastKey=wizBranch+'|'+wizSteps[wizIdx];
  if('ResizeObserver' in window){ rmRO=new ResizeObserver(()=>rmFit()); rmRO.observe(rmEls.fit); }
  rmStageVars();
  rmSuffixIds(ms);
  rmRenderRail(true);
  rmSync();
  rmFit();
  rmCenterActive();   // arrivée par lien (?design=, ?s=) : la carte active dans le rail
  rmBootOff();
}

function rmExit(fromPop){
  if(!rmOn()) return;
  fromPop=!!(fromPop||rmFromPop);
  try{ rmClosePicker(false); }catch(e){ rmWarn(e); }
  try{ rmCloseSheet(true); }catch(e){ rmWarn(e); }
  try{ rmKbOff(); }catch(e){ rmWarn(e); }
  if(rmRO){ rmRO.disconnect(); rmRO=null; }

  const mp=$('mobilePreview'), ms=$('mobileStage');
  const inner=mp&&mp.querySelector('.mobile-preview-inner');
  // #mobileStage remis avant .mobile-info, injections retirées
  if(ms&&inner){ const info=inner.querySelector('.mobile-info'); inner.insertBefore(ms,info&&info.parentNode===inner?info:null); }
  Object.keys(rmEls).forEach(k=>{ const n=rmEls[k]; if(k!=='situ'&&k!=='ar'&&n.parentNode) n.parentNode.removeChild(n); });
  // Nœuds remis à la place de leur commentaire (ordre inverse)
  [...rmMarks.values()].reverse().forEach(({node,mark})=>{ if(mark.parentNode){ mark.parentNode.insertBefore(node,mark); mark.parentNode.removeChild(mark); } });
  rmMarks.clear();
  rmSwapRestore();

  // Classes, verrou, aria-hidden
  [...body.classList].forEach(c=>{ if(c.indexOf('rm-')===0) body.classList.remove(c); });
  delete body.dataset.rmSheet;
  DE.classList.remove('rm-lock');
  rmAria.forEach((v,e)=>{ if(v==null) e.removeAttribute('aria-hidden'); else e.setAttribute('aria-hidden',v); });
  rmAria.clear();
  const root=$('rmApp'); if(root) root.hidden=true;

  // Le mode classique retrouve ses px : variables vidées, puis rendu d'origine
  if(mp){ ['--m-cw','--m-ch','--rm-bw','--rm-bh'].forEach(p=>mp.style.removeProperty(p)); if(!mp.getAttribute('style')) mp.removeAttribute('style'); }
  if(ms){ ms.style.width=''; ms.style.height=''; ms.style.borderRadius=''; }
  // Rendu d'origine seulement si le parcours reste ouvert (rotation, fenêtre élargie) : sortie vers
  // l'accueil (Quitter, ‹, retour navigateur) = état laissé par wizShowHome, sinon renderStage →
  // updateOrderRecap réaffiche #previewEstim (« env. … € TTC » + DEVIS inerte) sous les cartouches.
  try{ if(currentDesign&&body.classList.contains('wiz-on')) renderStage(); }catch(e){ rmWarn(e); }
  rmLastKey=null;

  // Sortie par l'interface : on consomme la sentinelle d'historique
  const hadSentinel=rmSentinel; rmSentinel=false;
  if(!fromPop&&hadSentinel){
    rmIgnorePop=true;
    clearTimeout(rmIgnoreTimer); rmIgnoreTimer=setTimeout(()=>{ rmIgnorePop=false; },1500);
    try{ history.back(); }catch(e){ rmIgnorePop=false; }
  }
}

// Pas de double sentinelle : retour sans bfcache sur une entrée déjà marquée {rm:1}
function rmPushSentinel(){
  if(rmSentinel) return;
  if(history.state&&history.state.rm){ rmSentinel=true; return; }
  try{ history.pushState({rm:1},''); rmSentinel=true; }catch(e){}
}

function rmQuit(){
  if(wizBranch==='create') exitCreateMode(); else wizShowHome();
  if(rmOn()) rmExit();   // garde-fou : l'enveloppe de wizShowHome a déjà fait sortir
  // Défilement instantané en haut du Studio (Dawn et la section imposent scroll-behavior:smooth)
  const app=$('rugierStudioApp'); if(!app) return;
  const prevStyle=DE.getAttribute('style');
  DE.style.scrollBehavior='auto';
  const top=app.getBoundingClientRect().top+window.scrollY;
  const y=top<(window.innerHeight||800)*0.6?0:Math.max(0,top-16);
  try{ window.scrollTo({top:y,left:0,behavior:'instant'}); }catch(e){ window.scrollTo(0,y); }
  if(prevStyle==null) DE.removeAttribute('style'); else DE.setAttribute('style',prevStyle);
}

// ‹ : nuancier → feuille → étape précédente → sortie
function rmBackAction(){
  if(body.classList.contains('rm-pick')) rmClosePicker(false);
  else if(body.classList.contains('rm-sheet')) rmCloseSheet();
  else if(wizIdx>0) wizBackStep();
  else rmQuit();
}

/* ============================================================
   Rendu du tapis : variables CSS, boîte disponible, id suffixés
   ============================================================ */
// --m-cw / --m-ch (cm) sur #mobilePreview ; rayon en % (même formule que renderMobilePreview)
function rmStageVars(w,h){
  if(w==null||h==null){
    if(!currentSize) return;
    const p=String(currentSize).split('x').map(Number); w=p[0]; h=p[1];
  }
  w=+w; h=+h; if(!(w>0&&h>0)) return;
  const mp=$('mobilePreview'), ms=$('mobileStage'); if(!mp||!ms) return;
  mp.style.setProperty('--m-cw',String(w));
  mp.style.setProperty('--m-ch',String(h));
  const r=Math.max(0.7,2.6-Math.min(w,h)*0.006);
  ms.style.borderRadius=(r/w*100)+'% / '+(r/h*100)+'%';
}
// Boîte réelle de #rmFit → --rm-bw / --rm-bh (px). Appelée par le ResizeObserver et à chaque changement de mode.
function rmFit(){
  if(!rmOn()) return;
  const f=rmEls.fit, mp=$('mobilePreview'); if(!f||!mp||!f.isConnected) return;
  const r=f.getBoundingClientRect();
  const bw=Math.max(0,Math.round(r.width*10)/10), bh=Math.max(40,Math.round(r.height*10)/10);
  if(mp.style.getPropertyValue('--rm-bw')!==bw+'px') mp.style.setProperty('--rm-bw',bw+'px');
  if(mp.style.getPropertyValue('--rm-bh')!==bh+'px') mp.style.setProperty('--rm-bh',bh+'px');
}
// Suffixe _rm sur tous les id DÉFINIS dans le SVG miroir, et sur leurs seules références :
// #stage (masqué, placé avant dans le DOM) définit les mêmes id (rugRound, rugClip, zg_*…).
// Les filtres globaux de la section (tufted, carving, rugedge…), non définis ici, restent intacts.
// Chaîne SVG/HTML → même chaîne aux id suffixés (null si rien à changer). « _rm_m » : id déjà
// suffixé puis passé par le « _m » des dégradés de renderMobilePreview.
function rmSuffixStr(html){
  if(!html||html.indexOf('id="')<0) return null;
  const ids=new Set(); let m; const re=/\sid="([^"]+)"/g;
  while((m=re.exec(html))){ if(!/_rm(_m)?$/.test(m[1])) ids.add(m[1]); }
  if(!ids.size) return null;
  let changed=false;
  const out=html.replace(/(\sid="|url\((?:&quot;|['"])?#|href="#)([^"')&]+)/g,(s,p,id)=>{ if(ids.has(id)){ changed=true; return p+id+'_rm'; } return s; });
  return changed?out:null;
}
function rmSuffixIds(root){
  if(!root) return;
  const out=rmSuffixStr(root.innerHTML);
  if(out!=null) root.innerHTML=out;
}

/* Textes d'origine remplacés le temps du plein écran (tiret cadratin, glyphes d'icône, « 200x300 »,
   libellés accessibles) : chaque remplacement est noté et rendu à l'identique par rmExit. */
const rmSwaps=[];   // {node, kind:'text'|'attr', name, orig, now}
function rmSwapText(node,txt){
  if(!node||node.textContent===txt) return;
  rmSwaps.push({node,kind:'text',orig:node.textContent,now:txt});
  node.textContent=txt;
}
function rmSwapAttr(el,name,val){
  if(!el||el.getAttribute(name)===val) return;
  rmSwaps.push({node:el,kind:'attr',name,orig:el.getAttribute(name),now:val});
  el.setAttribute(name,val);
}
function rmSwapRestore(){
  rmSwaps.splice(0).reverse().forEach(s=>{
    if(!s.node.isConnected) return;   // nœud re-rendu entre-temps : le rendu d'origine fait foi
    if(s.kind==='text'){ if(s.node.textContent===s.now) s.node.textContent=s.orig; }
    else if(s.node.getAttribute(s.name)===s.now){ if(s.orig==null) s.node.removeAttribute(s.name); else s.node.setAttribute(s.name,s.orig); }
  });
}
// « Carving — contours… » → « Carving, contours… » ; « ↻ Couleurs aléatoires — tout le tapis » →
// « Couleurs aléatoires, tout le tapis ». « ARS — » (aucun code) n'est pas touché.
function rmDashFix(root){
  if(!root) return;
  const w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
  const nodes=[]; while(w.nextNode()) nodes.push(w.currentNode);
  nodes.forEach(n=>{
    const t=n.textContent;
    if(!/—\s+\S|^\s*[↻⚄]\s/.test(t)) return;
    if(n.parentElement&&n.parentElement.closest('svg,script,style')) return;
    const out=t.replace(/^(\s*)[↻⚄]\s+/,'$1').replace(/^\s*—\s+(?=\S)/,', ').replace(/\s+—\s+(?=\S)/g,', ');
    if(out!==t) rmSwapText(n,out);
  });
}

/* ============================================================
   rmSync() : classes d'état, titre, sous-titre, actions du tapis
   ============================================================ */
function rmSync(){
  if(!rmOn()) return;
  const cur=wizSteps[wizIdx];
  [...body.classList].forEach(c=>{
    if((c.indexOf('rm-step-')===0&&c!=='rm-step-'+cur)||(c.indexOf('rm-branch-')===0&&c!=='rm-branch-'+wizBranch)) body.classList.remove(c);
  });
  if(cur) body.classList.add('rm-step-'+cur);
  if(wizBranch) body.classList.add('rm-branch-'+wizBranch);
  body.classList.toggle('rm-empty',!currentDesign&&!isCreateMode);
  body.classList.toggle('rm-mode-upload',wizBranch==='choose'&&chooseMode==='upload');
  const phf=rmEls.ph&&rmEls.ph.firstChild;
  if(phf){ const t=T(chooseMode==='upload'?'SVG · 10 couleurs max · 2 Mo':'Touchez un design pour le voir en grand'); if(phf.textContent!==t) phf.textContent=t; }

  // Titre et sous-titre (en feuille ou nuancier, les lots concernés posent leur propre titre)
  if(!body.classList.contains('rm-sheet')&&!body.classList.contains('rm-pick')){
    const t=$('rmTitle'), s=$('rmSub');
    if(t) t.textContent=cur?(WIZ_LABELS[cur]||''):'';
    if(s) s.textContent=cur?T('Étape %1 sur %2').replace('%1',String(wizIdx+1)).replace('%2',String(wizSteps.length)):'';
  }
  rmSyncHist();
  rmSyncActs();
  rmSyncBar();
}
// « Revenir en arrière » (et « Revenir en avant » de la feuille Plus, id attendu #rmFwd)
function rmSyncHist(){
  const hb=$('histBack'), ru=$('rmUndo'); if(hb&&ru) ru.disabled=!!hb.disabled;
  const hf=$('histFwd'), rf=$('rmFwd'); if(hf&&rf) rf.disabled=!!hf.disabled;
}
// En situation / Chez vous : mêmes drapeaux que #situBtn / #arBtn (CRM situEnabled, arEnabled)
function rmSyncActs(){
  const sb=$('situBtn'), ab=$('arBtn');
  if(rmEls.situ) rmEls.situ.hidden=!(currentDesign&&sb&&sb.style.display!=='none');
  if(rmEls.ar) rmEls.ar.hidden=!(currentDesign&&ab&&ab.style.display!=='none');
}

/* ============================================================
   Lot L2 : rails de l'étape (#rmRail) et zone d'import (.rm-upload)
   ------------------------------------------------------------
   Un rail par étape dans RM_RAILS : key() (reconstruction seulement si la clé change,
   pour garder le défilement horizontal), build(head, scroller), update(head, scroller)
   (classes actives, prix, libellés, à chaque passe). Les rails Composer (« cd ») et
   Outils (« tools ») sont ajoutés par le lot L3 sur le même modèle.
   ============================================================ */
let rmRailKey=null;          // clé du rail affiché (null = à reconstruire)
let rmSyncRaf=0;             // rmSyncSoon : un seul passage par image
let rmUp=null;               // .rm-upload (créée une fois dans #rmPanel)

const RM_ICON_RANDOM='<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h4.5c4 0 6 10 10.5 10H24"/><path d="M4 19h4.5c1.8 0 3.1-2 4.3-4.3"/><path d="M15.2 13.3C16.4 11 17.7 9 19.5 9H24"/><path d="M21 6l3 3-3 3"/><path d="M21 16l3 3-3 3"/></svg>';
const RM_ICON_ZONES='<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="5" y="5" width="8" height="8"/><rect x="15" y="5" width="8" height="8"/><rect x="5" y="15" width="8" height="8"/><rect x="15" y="15" width="8" height="8"/></svg>';

const rmBtn=(cls,html)=>{ const b=document.createElement('button'); b.type='button'; b.className=cls; if(html!=null) b.innerHTML=html; return b; };
const rmLbl=txt=>{ const s=document.createElement('span'); s.className='rm-rail-lbl'; s.textContent=txt; return s; };
const rmSetText=(el,t)=>{ if(el&&el.textContent!==t) el.textContent=t; };
const rmEur=n=>Number(n).toLocaleString('fr-FR');
const rmWH=sz=>String(sz||'').split('x').map(Number);
const rmStdSizes=()=>(typeof STANDARD_SIZES!=='undefined'&&Array.isArray(STANDARD_SIZES))?STANDARD_SIZES:['170x240','200x300','250x350','150x150','200x200','250x250'];

function rmRailName(){
  const cur=wizSteps[wizIdx];
  if(cur==='designSection') return (wizBranch==='choose'&&chooseMode==='upload')?'upload':'design';
  if(cur==='sizeSection') return 'size';
  if(cur==='colorSection') return 'color';
  if(cur==='createDesignSection') return 'cd';
  if(cur==='editorSection') return 'tools';
  return null;
}

const RM_RAILS={
  // ── Collection · Design : puces de collection + cartes (currentDesign n'entre PAS dans la clé) ──
  design:{
    key:()=>activeColl+'|'+(Array.isArray(DESIGNS)?DESIGNS.map(d=>d.id).join():''),
    build(head,sc){
      const chips=document.createElement('div'); chips.className='rm-chips';
      head.appendChild(chips);
      const all=rmBtn('rm-rail-link'); all.textContent=T('Tout voir ›');
      all.addEventListener('click',()=>rmOpenSheet('step'));
      head.appendChild(all);
      if(!Array.isArray(DESIGNS)||!DESIGNS.length){
        const m=document.createElement('p'); m.className='rm-rail-msg'; m.textContent=T('Chargement des designs'); sc.appendChild(m);
        return;
      }
      ['Tous',...new Set(DESIGNS.map(d=>d.collection))].forEach(coll=>{
        const c=rmBtn('rm-chip'+(coll===activeColl?' is-active':'')); c.textContent=coll==='Tous'?T('Tous'):coll;
        c.addEventListener('click',()=>{ if(coll===activeColl) return; activeColl=coll; renderCollFilter(); renderDesignGrid(); });
        chips.appendChild(c);
      });
      const ph=(typeof thumbPlaceholder==='function')?thumbPlaceholder():'';
      const list=activeColl==='Tous'?DESIGNS:DESIGNS.filter(d=>d.collection===activeColl);
      list.forEach(d=>{
        const card=rmBtn('rm-card','<img alt="" src="'+ph+'"><span></span>');
        card.dataset.id=d.id;
        card.lastChild.textContent=d.name||'';
        card.setAttribute('aria-label',d.name||'');
        card.addEventListener('click',()=>{ selectDesign(d.id); });
        const img=card.firstChild;
        loadDesign(d.id).then(o=>{
          if(!o||!o.previewSvg) return;
          // Même vignette que la grille d'origine (déjà calculée par mkDesignCard si possible)
          const gi=document.querySelector('#designGrid .design-card[data-id="'+(window.CSS&&CSS.escape?CSS.escape(d.id):d.id)+'"] img');
          img.src=(gi&&gi.src&&gi.src!==ph)?gi.src:framedThumb(recolorSvg(o.previewSvg,{}));
        }).catch(()=>{});
        sc.appendChild(card);
      });
    },
    update(head,sc){
      const id=(currentDesign&&!isCreateMode&&currentDesign.config)?currentDesign.config.id:null;
      sc.querySelectorAll('.rm-card').forEach(c=>c.classList.toggle('is-active',c.dataset.id===id));
    }
  },

  // ── Importer · Design : pas de rail, .rm-upload à la place (rmUpSync) ──
  upload:{ key:()=>'u', build(){}, update(){ rmUpSync(); } },

  // ── Taille : formats avec prix (priceFor, la formule du devis) + Carving ──
  size:{
    list(){ if(!currentDesign) return []; return isFreeSize()?rmStdSizes().slice():(currentDesign.config.sizes||[]).slice(); },
    key(){
      if(!currentDesign) return 'none';
      const custom=isFreeSize()&&this.list().indexOf(currentSize)<0;
      return currentDesign.config.id+'|'+isFreeSize()+'|'+(currentDesign.config.sizes||[]).join()+'|'+custom;
    },
    build(head,sc){
      if(!currentDesign) return;
      head.appendChild(rmLbl(T('Format')));
      if(isFreeSize()){ const a=rmBtn('rm-rail-link'); a.textContent=T('Sur mesure ›'); a.addEventListener('click',()=>rmOpenSheet('step')); head.appendChild(a); }
      const chip=(sz,custom)=>{
        const c=rmBtn('rm-size'+(custom?' rm-custom':''),'<span class="rm-rect"><i></i></span><b></b><small></small>');
        c.dataset.sz=sz;
        c.addEventListener('click',()=>{
          if(custom){ rmOpenSheet('step'); return; }
          if(sz===currentSize) return;          // même format : rien à refaire (évite une régénération Composer)
          if(isCreateMode&&rmBeforeSizeChange(sz)) return;
          _szSaved=null; currentSize=sz; renderSizePills(); renderStage();
        });
        return c;
      };
      const list=this.list();
      if(isFreeSize()&&list.indexOf(currentSize)<0) sc.appendChild(chip(currentSize,true));
      list.forEach(sz=>sc.appendChild(chip(sz,false)));
      const carv=rmBtn('rm-size rm-two rm-carv','<small></small><b></b>');
      carv.firstChild.textContent=T('Carving');
      carv.addEventListener('click',()=>{ const cb=document.querySelector('#sizeSection .carving-check'); if(cb) cb.click(); });
      sc.appendChild(carv);
    },
    update(head,sc){
      if(!currentDesign) return;
      const carving=activeFinishes.has('carving');
      let tints=0; try{ tints=countTintsOf(zonesForQuote()); }catch(e){}
      sc.querySelectorAll('.rm-size[data-sz]').forEach(c=>{
        const custom=c.classList.contains('rm-custom');
        if(custom) c.dataset.sz=currentSize;
        const sz=c.dataset.sz, wh=rmWH(sz), w=wh[0], h=wh[1];
        c.classList.toggle('is-active',sz===currentSize);
        if(!(w>0&&h>0)) return;
        const k=Math.min(36/w,44/h), i=c.querySelector('.rm-rect i');
        if(i){ i.style.width=Math.round(w*k)+'px'; i.style.height=Math.round(h*k)+'px'; }
        rmSetText(c.querySelector('b'),w+' × '+h);
        rmSetText(c.querySelector('small'),custom?T('Sur mesure'):'≈ '+rmEur(priceFor(w,h,carving,tints))+' €');
      });
      const cv=sc.querySelector('.rm-carv');
      if(cv){ cv.classList.toggle('is-active',carving); rmSetText(cv.querySelector('b'),T(carving?'Oui':'Non')); cv.setAttribute('aria-pressed',carving?'true':'false'); }
    }
  },

  // ── Coloris : palettes du design + Au hasard + Zone par zone ──
  color:{
    pals:()=>(currentDesign&&currentDesign.config&&currentDesign.config.palettes)||[],
    key(){ return currentDesign?currentDesign.config.id+'|'+JSON.stringify(this.pals().map(p=>[p.name,p.colors])):'none'; },
    build(head,sc){
      if(!currentDesign) return;
      head.appendChild(rmLbl(T('Palettes')));
      const a=rmBtn('rm-rail-link'); a.textContent=T('Zone par zone ›'); a.addEventListener('click',()=>rmOpenSheet('step')); head.appendChild(a);
      this.pals().forEach((pal,i)=>{
        const cols=Object.values(pal.colors||{});
        const c=rmBtn('rm-pal','<span class="rm-strip">'+cols.map(x=>'<i style="background:'+esc(x)+'"></i>').join('')+'</span><span class="rm-pal-name"></span>');
        c.dataset.i=String(i);
        c.lastChild.textContent=pal.name||'';
        c.addEventListener('click',()=>{ const row=document.querySelectorAll('#paletteList .palette-row')[i]; if(row) row.click(); });
        sc.appendChild(c);
      });
      const rnd=rmBtn('rm-act',RM_ICON_RANDOM+'<span></span>'); rnd.lastChild.textContent=T('Au hasard');
      rnd.addEventListener('click',()=>{ const b=$('randomColors'); if(b) b.click(); });
      sc.appendChild(rnd);
      const zz=rmBtn('rm-act',RM_ICON_ZONES+'<span></span>'); zz.lastChild.textContent=T('Zone par zone');
      zz.addEventListener('click',()=>rmOpenSheet('step'));
      sc.appendChild(zz);
    },
    update(head,sc){
      if(!currentDesign) return;
      const uc=userColors[currentDesign.config.id]||{}, pals=this.pals();
      sc.querySelectorAll('.rm-pal').forEach(c=>{
        const pal=pals[+c.dataset.i], keys=pal&&pal.colors?Object.keys(pal.colors):[];
        // Active si les couleurs de la palette sont exactement celles du tapis (pas activePalIdx, que « Au hasard » ne change pas)
        const on=keys.length>0&&keys.every(k=>String(uc[k]||'').toLowerCase()===String(pal.colors[k]||'').toLowerCase());
        c.classList.toggle('is-active',on);
      });
    }
  },

  // ── Composer · Design (lot L3) : Relancer, Gamme au hasard, 10 gammes tirées des ancres ──
  cd:{
    key:()=>'cd|'+rmGammesGet().length,
    build(head,sc){
      head.appendChild(rmLbl(T('Composition')));
      const a=rmBtn('rm-rail-link'); a.textContent=T('Palette sur mesure ›'); a.addEventListener('click',()=>rmOpenSheet('step')); head.appendChild(a);
      const gen=rmBtn('rm-act rm-gen',RM_ICON_RELAUNCH+'<span></span>'); gen.lastChild.textContent=T('Relancer');
      gen.addEventListener('click',()=>rmRelaunch());
      sc.appendChild(gen);
      const rnd=rmBtn('rm-act',RM_ICON_RANDOM+'<span></span>'); rnd.lastChild.textContent=T('Gamme au hasard');
      rnd.addEventListener('click',()=>{ editorState.genPalette=randomComboPalette(); rmRecolor(); });
      sc.appendChild(rnd);
      rmGammesGet().forEach((cols,i)=>{
        const g=rmBtn('rm-gamme','<span class="rm-strip">'+cols.map(x=>'<i style="background:'+esc(x)+'"></i>').join('')+'</span><small></small>');
        g.dataset.i=String(i);
        const lbl=T('%s coloris').replace('%s',String(cols.length));
        g.lastChild.textContent=lbl;
        g.setAttribute('aria-label',lbl);
        g.addEventListener('click',()=>{ editorState.genPalette=cols.slice(0,7); rmRecolor(); });
        sc.appendChild(g);
      });
    },
    update(head,sc){
      const cur=JSON.stringify((editorState&&editorState.genPalette)||[]), gs=rmGammesGet();
      sc.querySelectorAll('.rm-gamme').forEach(g=>{ const cols=gs[+g.dataset.i]; g.classList.toggle('is-active',!!cols&&JSON.stringify(cols.slice(0,7))===cur); });
    }
  },

  // ── Composer · Outils (lot L3) : retouches du tapis entier ; la boîte à outils complète est en feuille ──
  tools:{
    key:()=>'tools',
    build(head,sc){
      head.appendChild(rmLbl(T('Retouches')));
      const a=rmBtn('rm-rail-link'); a.textContent=T('Boîte à outils avancée ›'); a.addEventListener('click',()=>rmOpenSheet('step')); head.appendChild(a);
      const two=(cls,grp,val,icon)=>{
        const b=rmBtn('rm-tool '+cls,(icon||'')+'<small></small><b></b>');
        b.querySelector('small').textContent=grp; b.querySelector('b').textContent=val;
        b.setAttribute('aria-label',(grp?grp+' ':'')+val);
        return b;
      };
      const col=two('rm-w92',T('Couleurs'),T('Relancer'),RM_ICON_RANDOM);
      col.addEventListener('click',()=>{ const b=$('editorRandomAll'); if(b) b.click(); });
      sc.appendChild(col);
      const comp=two('rm-w92',T('Composition'),T('Relancer'),RM_ICON_RELAUNCH);
      comp.addEventListener('click',()=>rmRelaunch());
      sc.appendChild(comp);
      ['Aucune','Simple','Double','Triple'].forEach((v,n)=>{
        const b=two('rm-w72 rm-bord'+(n===0?' rm-sep':''),T('Bordure'),T(v),rmBorderIcon(n));
        if(n>0){ b.querySelector('small').setAttribute('aria-hidden','true'); b.querySelector('small').classList.add('rm-ghost'); }
        b.dataset.n=String(n);
        b.addEventListener('click',()=>rmSetBorderCount(n));
        sc.appendChild(b);
      });
    },
    update(head,sc){
      const b=editorState&&editorState.border, cren=!!(b&&b.style==='creneau'), cnt=b?(+b.count||0):0;
      sc.querySelectorAll('.rm-bord').forEach(x=>{
        const n=+x.dataset.n;
        x.classList.toggle('is-active',!!b&&cnt===n);
        x.setAttribute('aria-pressed',(!!b&&cnt===n)?'true':'false');
        x.disabled=!b||(cren&&n>1);
        // Bordure créneau : Double et Triple retirées du rail, comme dans la boîte à outils
        // d'origine (renderEditorToolbox ne propose alors qu'Aucun et Simple)
        x.hidden=cren&&n>1;
      });
    }
  }
};

/* ── Lot L3 : Composer (gammes, recoloration, bordure) ── */
const RM_ICON_RELAUNCH='<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 14a8 8 0 1 1-2.34-5.66"/><path d="M20 4v5h-5"/></svg>';
// Pictogramme de bordure : n cadres concentriques (0 = tapis sans bordure)
function rmBorderIcon(n){
  let s='<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="5" y="3" width="18" height="22"/>';
  for(let i=1;i<=n;i++){ const k=i*2.6; s+='<rect x="'+(5+k)+'" y="'+(3+k)+'" width="'+(18-2*k)+'" height="'+(22-2*k)+'"/>'; }
  return s+'</svg>';
}
// 10 ancres tirées une fois (par chargement de page), recalées sur l'ARS, dédoublonnées, triées par clarté
let rmGammes=null;
function rmGammesGet(){
  if(rmGammes) return rmGammes;
  let anchors=[]; try{ anchors=genAnchors()||[]; }catch(e){ rmWarn(e); }
  const idx=anchors.map((_,i)=>i);
  for(let i=idx.length-1;i>0;i--){ const j=Math.floor(Math.random()*(i+1)); const t=idx[i]; idx[i]=idx[j]; idx[j]=t; }
  const out=[];
  for(const i of idx){
    if(out.length>=10) break;
    const a=anchors[i]; if(!Array.isArray(a)||!a.length) continue;
    let cols=[]; try{ cols=[...new Set(a.map(arsSnap))].filter(Boolean).sort((x,y)=>hexToHsl(x).l-hexToHsl(y).l).slice(0,7); }catch(e){ continue; }
    if(cols.length>=2) out.push(cols);
  }
  rmGammes=out;
  return rmGammes;
}
// Recolore EN PLACE (même dessin) avec la palette imposée ; sans composition, en génère une
function rmRecolor(){
  const els=(editorState&&editorState.elements)||[];
  if(els.length||(editorState.border&&editorState.border.count)){ const b=$('editorRandomAll'); if(b) b.click(); }
  else rmRelaunch();
  if(typeof renderCdPalette==='function'){ try{ renderCdPalette(); }catch(e){ rmWarn(e); } }
  rmRenderRail();
}
// Nouvelle composition (bouton d'origine #cdRandom) : considérée intacte pour un changement de format
function rmRelaunch(){
  const b=$('cdRandom'); if(!b) return;
  rmGenerate(()=>b.click());
  rmAutoGenSnap=editorSnapshot();
}
/* Compositions tirées par le plein écran (entrée Composer, Relancer des rails, régénération à un
   changement de format) : jamais « vides ». Le gabarit « fond uni + bordure » de genLayouts (1 tirage
   sur 6) se lit comme un tapis vide sur l'écran du téléphone : nouveau tirage, borné à 8. Les tirages
   écartés ne restent ni dans l'annulation de l'éditeur (editorHistory) ni dans le ‹ du Studio
   (histStack, vidé EN PLACE comme l'exige historyGo). Le desktop garde le générateur tel quel.
   Mettre RM_GEN_NONEMPTY à false pour revenir au tirage d'origine. */
const RM_GEN_NONEMPTY=true;
const rmHasEls=()=>!!(editorState&&editorState.elements&&editorState.elements.length);
function rmGenerate(first){
  first();
  if(!RM_GEN_NONEMPTY) return;
  for(let n=0;n<8&&!rmHasEls();n++){
    let keep=null;
    try{ keep={e:editorHistory.slice(),s:histStack.slice()}; }catch(e){}
    generateRandomGeometry();
    if(keep){ try{
      editorHistory.splice(0,editorHistory.length,...keep.e);
      histStack.splice(0,histStack.length,...keep.s);
      if(typeof updateUndoBtn==='function') updateUndoBtn();
      updateHistBtns();
    }catch(e){ rmWarn(e); } }
  }
}
// Nombre de bandes de bordure (0..3), seuls des champs déjà sérialisés par getSnapshot
function rmSetBorderCount(n){
  const b=editorState&&editorState.border; if(!b) return;
  n=Math.max(0,Math.min(3,+n||0));
  if(b.style==='creneau') n=Math.min(n,1);
  if(n===(+b.count||0)) return;
  pushEditorHistory();
  if(!b.count&&n>0){
    const s=sortByLight([...new Set([editorState.bg,...(editorState.elements||[]).flatMap(e=>Object.values(e.colors||{}))])].filter(Boolean));
    if(s.length) b.colors=[0,1,2].map(i=>s[(i+1)%s.length]);
  }
  b.count=n;
  renderEditorToolbox(); renderEditorCanvas();
}

function rmRenderRail(force){
  if(!rmOn()) return;
  const head=document.querySelector('#rmRail .rm-rail-head'), sc=$('rmScroller'); if(!head||!sc) return;
  const name=rmRailName(), R=name?RM_RAILS[name]:null;
  let key='none';
  try{ key=R?name+'|'+R.key():'none|'+name; }catch(e){ rmWarn(e); key='err|'+name; }
  if(force||key!==rmRailKey){
    rmRailKey=key;
    // Même rail (ex. autre collection) : les puces de l'en-tête gardent leur défilement
    const oc=head.querySelector('.rm-chips'), chipsLeft=(oc&&sc.dataset.rail===name)?oc.scrollLeft:0;
    head.innerHTML=''; sc.innerHTML=''; sc.scrollLeft=0;
    sc.dataset.rail=name||'';
    if(R){ try{ R.build(head,sc); }catch(e){ rmWarn(e); } }
    if(R){ try{ R.update(head,sc); }catch(e){ rmWarn(e); } }
    const nc=head.querySelector('.rm-chips'); if(nc&&chipsLeft) nc.scrollLeft=chipsLeft;
    rmCenterActive();
  } else if(R){ try{ R.update(head,sc); }catch(e){ rmWarn(e); } }
}

// Centre la carte active dans #rmScroller : scrollTo, jamais scrollIntoView (qui ferait défiler la page)
function rmCenterActive(){
  if(!rmOn()) return;
  const sc=$('rmScroller'); if(!sc||!sc.clientWidth) return;
  // Rails Composer et Outils : les actions de tête (Relancer, Gamme au hasard, Couleurs et
  // Composition) restent visibles, la puce active (gamme, bordure) n'est pas centrée
  if(sc.dataset.rail==='cd'||sc.dataset.rail==='tools') return;
  const card=sc.querySelector('.is-active'); if(!card) return;
  const left=Math.max(0,card.offsetLeft-(sc.clientWidth-card.offsetWidth)/2);
  try{ sc.scrollTo({left,behavior:'instant'}); }catch(e){ sc.scrollLeft=left; }
}

// Zone d'import (Importer · Design) : bouton du sélecteur d'origine, rappel, statut recopié
function rmUpEnsure(){
  if(rmUp) return rmUp;
  const panel=$('rmPanel'); if(!panel) return null;
  rmUp=document.createElement('div'); rmUp.className='rm-upload';
  rmUp.innerHTML='<button type="button" class="btn rm-up-btn"></button><p class="rm-up-hint"></p><p class="rm-status" aria-live="polite"></p>';
  panel.insertBefore(rmUp,$('rmSheetBody'));
  rmUp.firstChild.addEventListener('click',()=>{ const inp=$('userSvgInput'); if(inp) inp.click(); });
  const st=$('userUploadStatus');
  if(st&&'MutationObserver' in window) new MutationObserver(()=>rmUpSync()).observe(st,{childList:true,characterData:true,subtree:true});
  return rmUp;
}
function rmUpSync(){
  const u=rmUpEnsure(); if(!u) return;
  const done=!!(currentDesign&&isUserDesign&&!isCreateMode);
  const b=u.querySelector('.rm-up-btn');
  b.classList.toggle('btn-out',done);
  rmSetText(b,T(done?'Importer un autre fichier':'Sélectionner un fichier SVG'));
  rmSetText(u.querySelector('.rm-up-hint'),T('SVG · 10 couleurs max · 2 Mo'));
  const st=$('userUploadStatus');
  rmSetText(u.querySelector('.rm-status'),st?st.textContent:'');
}

/* Composer : changement de format sur le rail Taille. Renvoie true si tout est fait.
   - composition vide → false (le clic poursuit normalement) ;
   - composition générée et jamais retouchée → nouvelle composition au nouveau format ;
   - sinon → éléments remis à l'échelle (le clic poursuit avec currentSize et renderStage). */
function rmBeforeSizeChange(sz){
  const els=(editorState&&editorState.elements)||[];
  const hasBorder=!!(editorState&&editorState.border&&editorState.border.count);
  if(!els.length&&!hasBorder) return false;
  if(rmAutoGenSnap&&editorSnapshot()===rmAutoGenSnap){
    currentSize=sz; renderSizePills();
    rmGenerate(generateRandomGeometry);
    rmAutoGenSnap=editorSnapshot();
    return true;
  }
  const a=rmWH(currentSize), b=rmWH(sz);
  if(!(a[0]>0&&a[1]>0&&b[0]>0&&b[1]>0)) return false;
  pushEditorHistory();
  const kx=b[0]/a[0], ky=b[1]/a[1];
  els.forEach(e=>{ e.x=Math.round(e.x*kx); e.w=Math.round(e.w*kx); e.y=Math.round(e.y*ky); e.h=Math.round(e.h*ky); });
  return false;
}

/* Composer : même règle quand le format change dans la feuille « Taille sur mesure » (puces
   #sizeStdPills et réglettes #sizeW/#sizeH de rugier-studio.js, branchées par référence donc non
   enveloppables). Écouteurs sur #sizeSection : en capture (avant le gestionnaire d'origine) on
   note le format et la géométrie de départ ; en bulle (après) on applique.
   - Réglette : un geste = des 'input' puis 'change'. Pendant le geste, mise à l'échelle depuis la
     géométrie de départ (pas d'arrondis cumulés), une seule entrée d'historique ; composition
     intacte : régénérée au 'change' (géométrie de départ remise avant, pour l'historique). */
let rmSzG=null;
function rmSzStart(){
  const es=editorState||{}, els=es.elements||[];
  return { from:currentSize, empty:!els.length&&!(es.border&&es.border.count),
    intact:!!(rmAutoGenSnap&&editorSnapshot()===rmAutoGenSnap), geo:els.map(e=>[e.x,e.y,e.w,e.h]), pushed:false };
}
function rmSzScale(G){
  const a=rmWH(G.from), b=rmWH(currentSize);
  if(!(a[0]>0&&a[1]>0&&b[0]>0&&b[1]>0)) return;
  if(!G.pushed&&!G.intact){ pushEditorHistory(); G.pushed=true; }
  const kx=b[0]/a[0], ky=b[1]/a[1];
  (editorState.elements||[]).forEach((e,i)=>{ const g=G.geo[i]; if(!g) return; e.x=Math.round(g[0]*kx); e.y=Math.round(g[1]*ky); e.w=Math.round(g[2]*kx); e.h=Math.round(g[3]*ky); });
  renderStage();
}
function rmSzEnd(G){
  if(!G||G.empty||currentSize===G.from) return;
  if(G.intact){
    (editorState.elements||[]).forEach((e,i)=>{ const g=G.geo[i]; if(g){ e.x=g[0]; e.y=g[1]; e.w=g[2]; e.h=g[3]; } });
    rmGenerate(generateRandomGeometry);
    rmAutoGenSnap=editorSnapshot();
  } else rmSzScale(G);
}
function rmSzWire(){
  const sec=$('sizeSection'); if(!sec) return;
  const on=()=>rmOn()&&isCreateMode;
  const isSlider=t=>t&&(t.id==='sizeW'||t.id==='sizeH');
  const pill=t=>t&&t.closest&&t.closest('.size-pill');
  let clickG=null;
  sec.addEventListener('click',e=>{ clickG=(on()&&pill(e.target))?rmSzStart():null; },true);
  sec.addEventListener('click',()=>{ const G=clickG; clickG=null; if(G&&on()) rmSzEnd(G); });
  // Nouveau geste (doigt posé) : un geste précédent resté sans 'change' est abandonné
  ['pointerdown','touchstart'].forEach(ev=>sec.addEventListener(ev,e=>{ if(isSlider(e.target)) rmSzG=null; },{capture:true,passive:true}));
  sec.addEventListener('input',e=>{
    if(!on()||!isSlider(e.target)) return;
    if(rmSzG&&rmSzG.geo.length!==((editorState&&editorState.elements)||[]).length) rmSzG=null;
    if(!rmSzG) rmSzG=rmSzStart();
  },true);
  sec.addEventListener('input',e=>{ const G=rmSzG; if(!G||!on()||!isSlider(e.target)||G.empty||currentSize===G.from) return; rmSzScale(G); });
  sec.addEventListener('change',e=>{ if(!isSlider(e.target)) return; const G=rmSzG; rmSzG=null; if(G&&on()) rmSzEnd(G); });
}

/* ============================================================
   Lot L2 : barre basse (#rmBar) et synchronisation différée
   ============================================================ */
function rmPrimaryMode(){
  if(body.classList.contains('rm-sheet')) return 'sheet';
  const cur=wizSteps[wizIdx];
  if(cur==='finishSection') return 'devis';
  if(cur&&wizIdx<wizSteps.length-1) return 'next';
  return null;
}
function rmSyncBar(){
  const lbl=$('rmPriceLbl'), pr=$('rmPrice'), btn=$('rmPrimary'); if(!lbl||!pr||!btn) return;
  const box=pr.parentNode, cur=wizSteps[wizIdx];
  if(!currentDesign&&!isCreateMode){
    rmSetText(lbl,'');
    rmSetText(pr,T(chooseMode==='upload'?'Choisissez un fichier':'Choisissez un design'));
    box.classList.add('is-hint');
  } else {
    const ol=$('orderBarLabel'), op=$('orderBarPrice');
    rmSetText(lbl,ol?ol.textContent:'');
    // L'espace fine insécable des milliers est quasi invisible en DM Sans : espace insécable normale.
    rmSetText(pr,op?op.textContent.replace(/\u202f/g,'\u00a0'):'');
    box.classList.remove('is-hint');
  }
  const m=rmPrimaryMode();
  btn.hidden=!m;
  if(m==='sheet'){ rmSetText(btn,T('Terminé')); btn.disabled=false; }
  else if(m==='devis'){ rmSetText(btn,T('Demander un devis')); btn.disabled=false; }
  else if(m==='next'){
    rmSetText(btn,T('Suivant : %s').replace('%s',WIZ_LABELS[wizSteps[wizIdx+1]]||''));
    btn.disabled=(cur==='designSection'&&!currentDesign);
  }
}
function rmPrimaryClick(){
  const m=rmPrimaryMode();
  if(m==='sheet') rmCloseSheet();
  else if(m==='devis'){
    const em=$('orderEmail'), so=$('sendOrder');
    if(em&&em.value.trim()){ if(so) so.click(); } else if(em) em.focus();
  }
  else if(m==='next') wizNextStep();
}
// Après updateOrderRecap (prix, libellés) : une passe rail + barre par image
function rmSyncSoon(){
  if(!rmOn()||rmSyncRaf) return;
  const raf=window.requestAnimationFrame?f=>requestAnimationFrame(f):f=>setTimeout(f,16);
  rmSyncRaf=raf(()=>{ rmSyncRaf=0; if(!rmOn()) return; try{ rmRenderRail(); rmSync(); }catch(e){ rmWarn(e); } }) || 1;
}

/* ============================================================
   Feuilles (L2 + L3) : step (Tout voir, Taille sur mesure, Zone par zone, Palette sur
   mesure, Boîte à outils avancée, Récapitulatif), save (Mes tapis), feed (La Galerie),
   more (Plus, contenu par rmBuildMore du lot Plus). Devis compact : CSS (lot L3).
   ============================================================ */
const RM_SHEET_STEP_TITLES={designSection:'Tout voir',sizeSection:'Taille sur mesure',colorSection:'Coloris zone par zone',createDesignSection:'Palette sur mesure',editorSection:'Boîte à outils avancée',finishSection:'Récapitulatif'};
// Titre de la feuille ouverte (aussi rappelé à la fermeture du nuancier, qui garde la feuille)
function rmSheetTitle(){
  const kind=body.dataset.rmSheet||'step';
  const title=kind==='step'?(RM_SHEET_STEP_TITLES[wizSteps[wizIdx]]||''):({save:'Mes tapis',feed:'La Galerie',more:'Plus'}[kind]||'');
  const t=$('rmTitle'), s=$('rmSub');
  if(t) t.textContent=title?T(title):'';
  if(s) s.textContent='';
}
function rmOpenSheet(kind){
  if(!rmOn()) return;
  kind=kind||'step';
  if(body.classList.contains('rm-pick')) rmClosePicker(false);
  body.classList.add('rm-sheet'); body.dataset.rmSheet=kind;
  rmSheetTitle();
  const sb=$('rmSheetBody'); if(sb) sb.scrollTop=0;
  // « Palette sur mesure » : pastilles recalées sur la palette imposée (une gamme du rail a pu la changer)
  if(kind==='step'&&wizSteps[wizIdx]==='createDesignSection'&&typeof renderCdPalette==='function'){ try{ renderCdPalette(); }catch(e){ rmWarn(e); } }
  if(kind==='more'&&typeof rmBuildMore==='function') rmBuildMore();
  if(kind==='feed') rmCardMeta($('feedGrid'));
  if(kind==='save') rmCardMeta($('myCards'));
  if(kind==='step') rmIconLabels();
  rmFit(); rmSync();
}
function rmCloseSheet(silent){
  if(!body.classList.contains('rm-sheet')&&!body.dataset.rmSheet) return;
  body.classList.remove('rm-sheet'); delete body.dataset.rmSheet;
  // Un champ de la feuille gardait le focus : l'état clavier tombe avec elle
  const ae=document.activeElement;
  if(ae&&rmIsField(ae)&&!ae.offsetWidth){ try{ ae.blur(); }catch(e){} rmKbOff(); }
  // La feuille a pu changer ce que montre le rail (palette imposée, bordure, format sur mesure)
  if(!silent){ rmFit(); rmRenderRail(); rmSync(); rmCenterActive(); }
}

/* ============================================================
   Lot L3 : clavier (étape Devis, champs des feuilles)
   ------------------------------------------------------------
   Focus dans un champ texte de #rmApp → body.rm-kb (barre, progression et actions du
   tapis masquées, tapis en vignette) ; #rmApp suit visualViewport (top/height, sans
   transform : #cfgAuthOverlay en fixed garde le viewport comme bloc conteneur).
   Réglettes et cases à cocher exclues : elles n'ouvrent pas de clavier.
   ============================================================ */
let rmKbVV=false;
function rmIsField(el){
  if(!el||!el.closest||!el.closest('#rmApp')) return false;
  if(el.tagName==='TEXTAREA') return true;
  if(el.tagName!=='INPUT') return false;
  return /^(text|email|number|search|tel|url|password)$/i.test(el.type||'text');
}
function rmKb(){
  const app=$('rmApp'), vv=window.visualViewport;
  if(!app||!body.classList.contains('rm-kb')||!vv) return;
  app.style.top=Math.max(0,vv.offsetTop)+'px';
  app.style.height=vv.height+'px';
  app.style.bottom='auto';
}
function rmKbOn(target){
  if(!rmOn()) return;
  body.classList.add('rm-kb');
  const vv=window.visualViewport;
  if(vv&&!rmKbVV){ vv.addEventListener('resize',rmKb); vv.addEventListener('scroll',rmKb); rmKbVV=true; }
  rmKb(); rmFit();
  // Champ amené dans le panneau seulement (jamais scrollIntoView : la page verrouillée défilerait)
  setTimeout(()=>{
    if(!target||!target.isConnected) return;
    const sc=target.closest('#rmSheetBody,#rmMore'); if(!sc) return;
    const r=target.getBoundingClientRect(), s=sc.getBoundingClientRect();
    const btn=target.closest('.email-row');   // le bouton d'envoi réaffiché sous le champ reste visible
    const bottom=btn?btn.getBoundingClientRect().bottom:r.bottom;
    if(r.top<s.top+8) sc.scrollTop-=(s.top+8-r.top);
    else if(bottom>s.bottom-8) sc.scrollTop+=Math.min(bottom-(s.bottom-8),r.top-(s.top+8));
  },50);
}
function rmKbOff(){
  const vv=window.visualViewport;
  if(vv&&rmKbVV){ vv.removeEventListener('resize',rmKb); vv.removeEventListener('scroll',rmKb); rmKbVV=false; }
  const app=$('rmApp'); if(app){ app.style.top=''; app.style.height=''; app.style.bottom=''; if(!app.getAttribute('style')) app.removeAttribute('style'); }
  if(!body.classList.contains('rm-kb')) return;
  body.classList.remove('rm-kb');
  rmFit();
}
/* ============================================================
   Lot L4 : nuancier ARS plein écran (#rmPicker), clic seul
   ------------------------------------------------------------
   openArsPicker(currentHex, onApply, anchorEl) est enveloppée : dans l'app, rmOpenPicker.
   - currentHex fourni (« live ») : chaque toucher applique la teinte (onApply) ; Annuler,
     ‹ ou retour navigateur remettent la couleur d'origine ; Valider garde la dernière.
   - currentHex null (ajout d'un coloris) : rien n'est appliqué avant Valider.
   Onglets : Proches (30 teintes par colDist), Du design (≥ 2 teintes), plateaux 001–300
   et 301–600 (cases d'arsTraysHtml). Pipette : toucher le tapis du haut.
   body.rm-sheet est conservée : à la fermeture, on retrouve la feuille d'origine.
   ============================================================ */
let rmPick=null;   // {live, f, origHex, origCode, cur, pending:{hex,cs}|null, tab, design:[codes]}
const RM_PICK_TABS=[['near','Proches'],['design','Du design'],['t1','ARS 001–300'],['t2','ARS 301–600']];

// Codes ARS « du design » : palettes du catalogue ; en Composer, gamme imposée + couleurs du tapis
function rmPickDesignCodes(){
  const hexes=[];
  const push=c=>{ if(typeof c==='string'&&/^#[0-9a-f]{3,8}$/i.test(c)) hexes.push(c); };
  try{
    if(isCreateMode){
      ((editorState&&editorState.genPalette)||[]).forEach(push);
      ((editorState&&editorState.elements)||[]).forEach(e=>Object.values(e.colors||{}).forEach(push));
      if(editorState){ push(editorState.bg); if(editorState.border&&editorState.border.count) (editorState.border.colors||[]).slice(0,editorState.border.count).forEach(push); }
    } else if(currentDesign&&currentDesign.config){
      (currentDesign.config.palettes||[]).forEach(p=>Object.values((p&&p.colors)||{}).forEach(push));
    }
  }catch(e){ rmWarn(e); }
  const seen=new Set(), out=[];
  hexes.forEach(h=>{ const a=arsNearest(h); if(a&&!seen.has(a.code)){ seen.add(a.code); out.push(+a.code); } });
  return out;
}
const rmPickSelCode=()=>rmPick?(rmPick.pending?+rmPick.pending.cs:(rmPick.cur?+rmPick.cur.code:null)):null;
function rmPickMark(code,scroll){
  const grid=$('rmPickGrid'); if(!grid) return;
  grid.querySelectorAll('.sel').forEach(x=>x.classList.remove('sel'));
  if(code==null) return;
  const cell=grid.querySelector('[data-code="'+code+'"]'); if(!cell) return;
  cell.classList.add('sel');
  if(scroll){
    // Défilement de la grille seule (jamais scrollIntoView : la page verrouillée défilerait)
    const g=grid.getBoundingClientRect(), c=cell.getBoundingClientRect();
    grid.scrollTop=Math.max(0,grid.scrollTop+(c.top-g.top)-(grid.clientHeight-c.height)/2);
  }
}
function rmPickRender(tab){
  const P=rmPick, grid=$('rmPickGrid'), tabs=$('rmPickTabs'); if(!P||!grid||!tabs) return;
  P.tab=tab;
  tabs.querySelectorAll('[data-tab]').forEach(b=>{ const on=b.dataset.tab===tab; b.classList.toggle('is-active',on); b.setAttribute('aria-selected',on?'true':'false'); });
  const sw=code=>'<button type="button" class="rm-sw" data-code="'+code+'" style="background:'+ARS_HEX[code-1]+'" aria-label="ARS '+String(code).padStart(3,'0')+'"></button>';
  let html='';
  if(tab==='near'){
    const ref=P.origHex||'#888888';
    html='<div class="rm-near">'+ARS.slice().sort((x,y)=>colDist(ref,x.hex)-colDist(ref,y.hex)).slice(0,30).map(a=>sw(+a.code)).join('')+'</div>';
  } else if(tab==='design'){
    html='<div class="rm-near">'+P.design.map(sw).join('')+'</div>';
  } else {
    const tmp=document.createElement('div'); tmp.innerHTML=arsTraysHtml();
    const tr=tmp.querySelectorAll('.ars-tray')[tab==='t1'?1:0];
    html=tr?tr.outerHTML:'';
  }
  grid.innerHTML=html;
  grid.scrollTop=0;
  rmPickMark(rmPickSelCode(),tab==='t1'||tab==='t2');
}
function rmPickSyncOk(){
  const ok=$('rmPickOk'); if(ok) ok.disabled=!!(rmPick&&!rmPick.live&&!rmPick.pending);
}
function rmPickSelect(code){
  const P=rmPick; code=+code; if(!P||!(code>=1&&code<=ARS_HEX.length)) return;
  const cs=String(code).padStart(3,'0'), hex=ARS_HEX[code-1];
  P.pending={hex,cs};
  rmPickMark(code,false);
  rmSetText($('rmSub'),'ARS '+cs);
  rmPickSyncOk();
  if(P.live){ try{ P.f(hex,cs); }catch(e){ rmWarn(e); } }
}
function rmOpenPicker(h,f,a){
  if(!rmOn()||typeof f!=='function') return;
  try{ closeArsInline(); }catch(e){ rmWarn(e); }
  if(rmPick||body.classList.contains('rm-pick')) rmClosePicker(false);
  const live=!!h, cur=h?arsNearest(h):null;
  try{ _arsCurCode=cur?+cur.code:null; }catch(e){}
  rmPick={live,f,origHex:h||null,origCode:cur?cur.code:null,cur,pending:null,tab:'near',design:rmPickDesignCodes()};
  // Titre : libellé de la zone (texte avant le code ARS), sinon « Coloris » / « Ajouter un coloris »
  const zone=a&&a.closest&&a.closest('.color-zone'), lab=zone&&zone.querySelector('.zone-label');
  const title=((lab&&lab.firstChild&&lab.firstChild.nodeType===3&&lab.firstChild.textContent)||'').trim()||T(live?'Coloris':'Ajouter un coloris');
  rmSetText($('rmTitle'),title);
  rmSetText($('rmSub'),cur?'ARS '+cur.code:'');
  const tabs=$('rmPickTabs');
  if(tabs){
    tabs.innerHTML='';
    tabs.setAttribute('role','tablist');
    RM_PICK_TABS.forEach(([k,l])=>{
      if(k==='design'&&rmPick.design.length<2) return;
      const b=rmBtn('rm-tab'); b.dataset.tab=k; b.setAttribute('role','tab'); b.textContent=T(l);
      tabs.appendChild(b);
    });
  }
  const ae=document.activeElement; if(ae&&ae!==body&&ae.blur&&ae.closest&&ae.closest('#rmApp')){ try{ ae.blur(); }catch(e){} }
  body.classList.add('rm-pick');
  rmPickRender('near');
  rmPickSyncOk();
  rmFit(); rmSync();
}
function rmClosePicker(commit){
  const P=rmPick;
  if(!P&&!body.classList.contains('rm-pick')) return;
  rmPick=null;
  if(P){
    try{
      if(commit&&P.pending&&!P.live) P.f(P.pending.hex,P.pending.cs);
      else if(!commit&&P.live&&P.pending&&P.origHex) P.f(P.origHex,P.origCode);
    }catch(e){ rmWarn(e); }
  }
  try{ _arsCurCode=null; }catch(e){}
  body.classList.remove('rm-pick');
  const g=$('rmPickGrid'), t=$('rmPickTabs'); if(g) g.innerHTML=''; if(t) t.innerHTML='';
  const ok=$('rmPickOk'); if(ok) ok.disabled=false;
  if(body.classList.contains('rm-sheet')) rmSheetTitle();
  rmFit(); rmSync();
}
// Pipette : toucher le tapis pendant que le nuancier est ouvert (bascule sur le bon plateau)
function rmPickPipette(e){
  if(!rmPick||!body.classList.contains('rm-pick')) return;
  let hx=null; try{ hx=pickHexAt(e); }catch(_){}
  const c=hx&&arsNearest(hx); if(!c) return;
  const code=+c.code, tab=code<=300?'t1':'t2';
  if(rmPick.tab!==tab) rmPickRender(tab);
  rmPickSelect(code);
  rmPickMark(code,true);
}

/* ============================================================
   Lot L4 : feuille « Plus » (rmBuildMore) et Chez vous (AR)
   ============================================================ */
const RM_MORE_ICON={
  share:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"/><path d="M8 7l4-4 4 4"/><path d="M6 11H5v10h14V11h-1"/></svg>',
  link:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1"/><path d="M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1"/></svg>',
  image:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14"/><circle cx="9" cy="10" r="1.6"/><path d="M21 16l-5-5-8 8"/></svg>',
  redo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 7l4 4-4 4"/><path d="M19 11h-9a5 5 0 0 0 0 10h3"/></svg>',
  save:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h12v18l-6-4-6 4z"/></svg>',
  mine:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="4" width="7" height="7"/><rect x="13" y="4" width="7" height="7"/><rect x="4" y="13" width="7" height="7"/><rect x="13" y="13" width="7" height="7"/></svg>',
  feed:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="6" width="5" height="12"/><rect x="9.5" y="4" width="5" height="16"/><rect x="16" y="6" width="5" height="12"/></svg>',
  user:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.2-4 4.2-6 8-6s6.8 2 8 6"/></svg>',
  exit:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4H5v16h9"/><path d="M10 12h11"/><path d="M17 8l4 4-4 4"/></svg>'
};
function rmMoreRow(id,icon,label,onClick,extra){
  const b=rmBtn('rm-more-row',(RM_MORE_ICON[icon]||'')+'<span class="rm-more-txt"><span class="rm-more-lbl sh-lbl"></span></span>');
  b.id=id;
  b.querySelector('.rm-more-lbl').textContent=label;
  if(extra&&extra.sub){ const s=document.createElement('small'); s.className='rm-more-sub'; s.textContent=extra.sub; b.querySelector('.rm-more-txt').appendChild(s); }
  if(extra&&extra.chev){ const c=document.createElement('span'); c.className='rm-more-chev'; c.setAttribute('aria-hidden','true'); c.textContent='›'; b.appendChild(c); }
  b.addEventListener('click',()=>{ try{ onClick(b); }catch(e){ rmWarn(e); } });
  return b;
}
async function rmCopyLink(btn){
  const lbl=btn&&btn.querySelector('.rm-more-lbl');
  let u; try{ u=await buildShareUrl(); }catch(e){ rmWarn(e); return; }
  try{
    await navigator.clipboard.writeText(u);
    if(lbl){ const o=lbl.textContent; lbl.textContent=T('Lien copié ✓'); setTimeout(()=>{ if(lbl.isConnected) lbl.textContent=o; },1800); }
  }catch(e){ try{ window.prompt(T('Copiez ce lien :'),u); }catch(_){} }
}
function rmBuildMore(){
  const box=$('rmMore'); if(!box) return;
  box.innerHTML='';
  const hasRug=!!(currentDesign||isCreateMode);
  const isUpload=!!(isUserDesign&&!isCreateMode);
  // Partager et Copier le lien : pas pour un import (le SVG n'est pas dans le lien) ni sans tapis
  if(hasRug&&!isUpload){
    box.appendChild(rmMoreRow('rmMShare','share',T('Partager'),b=>shareDesign(b)));
    box.appendChild(rmMoreRow('rmMCopy','link',T('Copier le lien'),b=>rmCopyLink(b),{sub:T('Pour continuer sur ordinateur')}));
  }
  if(hasRug) box.appendChild(rmMoreRow('rmMJpeg','image',T('Image (JPEG)'),()=>downloadJpeg()));
  box.appendChild(rmMoreRow('rmFwd','redo',T('Revenir en avant'),()=>historyGo(1)));
  if(hasRug){
    const sv=rmMoreRow('rmMSave','save',T('Enregistrer ce tapis'),()=>{
      const sb=$('saveBtn'); if(!sb||sb.disabled) return;
      const authed=!!authUser();
      sb.click();
      if(authed&&currentDesign) rmOpenSheet('save');   // le nouveau tapis apparaît dans « Mes tapis »
    });
    const sb=$('saveBtn'); if(sb&&sb.disabled) sv.disabled=true;
    box.appendChild(sv);
  }
  box.appendChild(rmMoreRow('rmMMine','mine',T('Mes tapis'),()=>rmOpenSheet('save'),{chev:true}));
  box.appendChild(rmMoreRow('rmMFeed','feed',T('La Galerie'),()=>rmOpenSheet('feed'),{chev:true}));

  // Changer de parcours : segments d'origine (#pathSwitch) télécommandés
  const blk=document.createElement('div'); blk.className='rm-more-block';
  const h=document.createElement('p'); h.className='rm-more-h'; h.textContent=T('Changer de parcours'); blk.appendChild(h);
  const segs=document.createElement('div'); segs.className='rm-paths';
  const curPath=(typeof currentPath==='function')?currentPath():'';
  // Clés « … (parcours) » : les clés exactes « Collection » / « Importer » traduiraient aussi les
  // segments statiques de #pathSwitch sur desktop EN/ES (translateStaticDom). En français, T rend
  // la clé : on affiche alors le libellé court.
  [['collection','Collection (parcours)','Collection'],['create','Composer','Composer'],['upload','Importer (parcours)','Importer']].forEach(([p,k,fr])=>{
    const tk=T(k);
    const s=rmBtn('rm-path'+(p===curPath?' is-active':'')); s.dataset.path=p; s.textContent=tk===k?fr:tk;
    s.setAttribute('aria-pressed',p===curPath?'true':'false');
    s.addEventListener('click',()=>{
      if(p===((typeof currentPath==='function')?currentPath():'')){ rmCloseSheet(); return; }
      const seg=document.querySelector('#pathSwitch .path-seg[data-path="'+p+'"]'); if(!seg) return;
      rmCloseSheet(true);
      if(p==='create') rmFreshCreate=true;
      seg.click();
      if(rmOn()){ rmRenderRail(); rmSync(); }
    });
    segs.appendChild(s);
  });
  blk.appendChild(segs); box.appendChild(blk);

  // Compte léger
  const u=authUser();
  if(u){
    const acc=document.createElement('div'); acc.className='rm-more-account'; acc.id='rmMAccount';
    acc.innerHTML=RM_MORE_ICON.user+'<span class="rm-more-txt"><span class="rm-more-lbl"></span></span>';
    acc.querySelector('.rm-more-lbl').textContent=T('Connecté en tant que')+' '+(u.email||'');
    if(u.kind==='cfg'&&typeof cfgLogout==='function'){
      const ch=rmBtn('rm-more-link'); ch.textContent=T('changer');
      ch.addEventListener('click',()=>{ try{ cfgLogout(); }catch(e){ rmWarn(e); } if(body.dataset.rmSheet==='more') rmBuildMore(); });
      acc.appendChild(ch);
    }
    box.appendChild(acc);
  } else {
    box.appendChild(rmMoreRow('rmMAccount','user',T("S'identifier"),()=>openCfgAuth(()=>{ if(rmOn()&&body.dataset.rmSheet==='more') rmBuildMore(); })));
  }
  box.appendChild(rmMoreRow('rmMQuit','exit',T('Quitter le Studio'),()=>{ rmCloseSheet(true); rmQuit(); }));
  const fn=$('footerNote'), ft=fn?fn.textContent.trim():'';
  if(ft){ const p=document.createElement('p'); p.className='rm-more-foot'; p.textContent=ft; box.appendChild(p); }
  box.scrollTop=0;
  rmSyncHist();
}

// Chez vous (AR) : lien ?s= posé dans l'URL avant de partir (retour sans bfcache), puis arOpen.
async function rmAr(){
  if(!(isUserDesign&&!isCreateMode)){
    try{ const u=await buildShareUrl(); if(u) history.replaceState(history.state,'',u); }catch(e){}
  }
  arOpen();
}
// #arBtn → #rmAr : « Préparation… », message d'erreur et disabled recopiés (textes passés par T)
let rmArObs=null;
function rmArWatch(){
  const ab=$('arBtn'); if(!ab||rmArObs||!('MutationObserver' in window)) return;
  const idle=ab.textContent.trim();
  const sync=()=>{
    const ra=rmEls.ar; if(!ra) return;
    const t=ab.textContent.trim();
    // Texte de repos : libellé court du plein écran ; sinon le message d'origine, traduit, sans tiret cadratin
    rmSetText(ra,(t===idle||!t)?T('Chez vous (AR)'):T(t).replace(/\s*—\s*/g,', '));
    ra.disabled=!!ab.disabled;
  };
  rmArObs=new MutationObserver(sync);
  rmArObs.observe(ab,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['disabled']});
  sync();
}

/* ============================================================
   Enveloppes de parcours
   ============================================================ */
function wrapAfter(name,after){
  const o=window[name];
  window[name]=function(){
    const r=o.apply(this,arguments);
    try{ after(arguments); }catch(e){ rmWarn(e); }
    return r;
  };
}

wrapAfter('startWizard',()=>{ rmApply(); });

// Sortie du plein écran vers l'accueil : pas de résidu (aperçu .has-design, barre « Commandez ce
// tapis »). Seulement si le plein écran était actif : ancienne mise en page (≤ 900 px sans tactile,
// ?classique=1, case décochée) strictement inchangée. Retirer `wasOn` pour l'appliquer partout.
{
  const o=window.wizShowHome;
  window.wizShowHome=function(){
    const wasOn=rmOn();
    const r=o.apply(this,arguments);
    try{
      if(wasOn){
        const mp=$('mobilePreview'); if(mp) mp.classList.remove('has-design');
        if(typeof refreshOrderBar==='function') refreshOrderBar();
      }
      rmApply();
    }catch(e){ rmWarn(e); }
    return r;
  };
}

wrapAfter('wizRender',()=>{
  if(!rmOn()) return;
  const key=wizBranch+'|'+wizSteps[wizIdx];
  if(key!==rmLastKey){ rmLastKey=key; rmClosePicker(false); rmCloseSheet(true); }
  rmRenderRail();
  rmSync();
});

{ // En plein écran, pas de défilement de page : on note seulement l'étape
  const o=window.scrollStepIntoView;
  window.scrollStepIntoView=function(id){
    if(rmOn()){ _lastScrollStep=id; return; }
    return o.apply(this,arguments);
  };
}

wrapAfter('enterCreateMode',()=>{
  if(rmOn()&&rmFreshCreate&&editorState&&!(editorState.elements&&editorState.elements.length)&&!(editorState.border&&editorState.border.count)){
    rmGenerate(generateRandomGeometry);
    rmAutoGenSnap=editorSnapshot();
  }
  rmFreshCreate=false;
});

{ // async : historyGo attend toujours la promesse (restauration silencieuse intacte)
  const o=window.applySnapshot;
  window.applySnapshot=async function(snap,quiet){
    const r=await o.apply(this,arguments);
    if(!quiet&&rmOn()){ try{ rmCloseSheet(true); rmCenterActive(); rmSync(); }catch(e){ rmWarn(e); } }
    return r;
  };
}

/* ============================================================
   Enveloppes de rendu
   ============================================================ */
{ // id suffixés dans la CHAÎNE avant le rendu : une seule analyse HTML (au lieu de réanalyser
  // l'innerHTML posé, ≈ 40 % du coût de renderStage sur Agata, à chaque input de réglette)
  const o=window.renderMobilePreview;
  window.renderMobilePreview=function(svg,w,h){
    if(!rmOn()||typeof svg!=='string') return o.apply(this,arguments);
    const args=[...arguments];
    try{ const s=rmSuffixStr(svg); if(s!=null) args[0]=s; }catch(e){ rmWarn(e); }
    const r=o.apply(this,args);
    try{ rmStageVars(w,h); }catch(e){ rmWarn(e); }
    return r;
  };
}
wrapAfter('renderEditorCanvas',()=>{
  if(!rmOn()||(typeof editorDrag!=='undefined'&&editorDrag)) return;
  rmStageVars();
  rmSuffixIds($('mobileStage'));
});

/* ============================================================
   Enveloppes de synchronisation (lot L2)
   ============================================================ */
// Prix, libellés de la barre, prix des puces : une passe par image après chaque recalcul
wrapAfter('updateOrderRecap',()=>{ rmSyncSoon(); });
wrapAfter('updateHistBtns',()=>{ if(rmOn()) rmSyncHist(); });
wrapAfter('updateSituBtn',()=>{ if(rmOn()) rmSyncActs(); });
// Le rail suit les rendus d'origine : reconstruit seulement si sa clé change, sinon classes actives
['renderDesignGrid','renderPaletteList','renderSizePills'].forEach(n=>wrapAfter(n,()=>{ if(rmOn()) rmRenderRail(); }));

{ // Nuancier (lot L4) : dans l'app, nuancier plein écran ; l'admin (#adminOverlay, hors .app) garde l'ancien
  const o=window.openArsPicker;
  window.openArsPicker=function(h,f,a){
    if(rmOn()&&a&&a.closest&&a.closest('#rugierStudioApp')) return rmOpenPicker(h,f,a);
    return o.apply(this,arguments);
  };
}

// En situation : légende sans tiret cadratin (texte posé par situRenderScene à chaque rendu)
if(typeof window.situRenderScene==='function') wrapAfter('situRenderScene',()=>{ if(rmOn()) rmDashFix($('situHint')); });

// Mes tapis / La Galerie : « 200x300 » → « 200 × 300 » dans les cartes (feuilles du plein écran).
// Cartes déjà construites : à l'ouverture de la feuille ; cartes construites ensuite : enveloppes.
function rmCardMeta(root){
  if(!rmOn()||!root) return;
  root.querySelectorAll('.card-meta').forEach(m=>{
    const n=m.firstChild; if(!n||n.nodeType!==3) return;
    const t=n.textContent, out=t.replace(/^(\s*\d+)\s*x\s*(\d+\s*)$/,'$1 × $2');
    if(out!==t) rmSwapText(n,out);
  });
}
['mkFeedCard','mkMyCard'].forEach(n=>{ if(typeof window[n]!=='function') return;
  const o=window[n];
  window[n]=function(){ const card=o.apply(this,arguments); try{ if(card&&card.nodeType===1) rmCardMeta(card); }catch(e){ rmWarn(e); } return card; };
});

// Palette sur mesure : ✕ et ⚄ dessinés en icônes par le CSS ; libellés accessibles posés ici
function rmIconLabels(){
  if(!rmOn()) return;
  document.querySelectorAll('#rmSheetBody .gen-chip-x').forEach(b=>{
    const t=(b.parentElement&&b.parentElement.getAttribute('title'))||'';
    rmSwapAttr(b,'aria-label',T('Retirer ce coloris')+(t?' '+t:''));
  });
  const dice=document.querySelector('#rmSheetBody #cdPalDice'); if(dice) rmSwapAttr(dice,'aria-label',T('Tirer une palette au hasard'));
  const x=document.querySelector('#rmSheetBody #cdPalX'); if(x) rmSwapAttr(x,'aria-label',T('Vider la palette'));
}
if(typeof window.renderCdPalette==='function') wrapAfter('renderCdPalette',()=>rmIconLabels());

{ // Choix dans la feuille « Tout voir » : la feuille se referme et la carte est centrée dans le rail
  const o=window.selectDesign;
  window.selectDesign=function(){
    const r=o.apply(this,arguments);
    Promise.resolve(r).then(()=>{
      if(rmOn()&&body.dataset.rmSheet==='step'&&wizSteps[wizIdx]==='designSection') rmCloseSheet();
    },()=>{});
    return r;
  };
}

/* ============================================================
   Branchements globaux
   ============================================================ */
// Composer par la cartouche : capture sur l'ancêtre (passe avant l'écouteur de #choiceCreate)
{ const ch=$('designChooser'); if(ch) ch.addEventListener('click',e=>{ if(e.target&&e.target.closest&&e.target.closest('#choiceCreate')) rmFreshCreate=true; },true); }

// Composer : format changé dans la feuille « Taille sur mesure » (correction tour 1)
rmSzWire();

// Clavier (lot L3) : focus dans un champ texte de #rmApp → rm-kb ; sortie 120 ms après la perte du focus
{ const app=$('rugierStudioApp');
  if(app){
    app.addEventListener('focusin',e=>{ if(rmOn()&&rmIsField(e.target)) rmKbOn(e.target); });
    app.addEventListener('focusout',()=>{
      setTimeout(()=>{ if(!rmIsField(document.activeElement)) rmKbOff(); },120);
    });
  }
}

if(MQ.addEventListener) MQ.addEventListener('change',rmApply); else if(MQ.addListener) MQ.addListener(rmApply);
addEventListener('pageshow',e=>{ if(e.persisted) rmApply(); });

// Retour navigateur : nuancier → feuille → étape précédente → sortie du Studio
addEventListener('popstate',()=>{
  if(rmIgnorePop){ rmIgnorePop=false; clearTimeout(rmIgnoreTimer); return; }
  if(!rmOn()) return;
  rmSentinel=false;   // l'entrée sentinelle vient d'être dépilée
  if(body.classList.contains('rm-pick')) rmClosePicker(false);
  else if(body.classList.contains('rm-sheet')) rmCloseSheet();
  else if(wizIdx>0) wizBackStep();
  else { rmFromPop=true; try{ rmQuit(); }finally{ rmFromPop=false; } return; }
  if(rmOn()) rmPushSentinel();
});

// Écran de chargement d'un lien profond : retiré à l'activation, ou 2,5 s après
// l'arrivée des données si le lien n'aboutit pas (la section le coupe aussi à 20 s).
function rmBootWatch(){
  if(!DE.classList.contains('rm-boot')) return;
  if(!(MQ.matches||FORCE)||!cssReady()){ rmBootOff(); return; }
  // Sondage à 100 ms et délai de 2,3 s : écran retiré ≤ 2,5 s après l'index même avec la dérive
  // des minuteurs pendant le chargement (300 ms + 2,5 s dépassait parfois les 3 s)
  const t0=Date.now(); let since=0;
  const iv=setInterval(()=>{
    if(!DE.classList.contains('rm-boot')||rmOn()||Date.now()-t0>20000){ rmBootOff(); clearInterval(iv); return; }
    let ready=false;
    if((Q.has('design')||Q.has('s'))&&Array.isArray(DESIGNS)&&DESIGNS.length) ready=true;
    if(Q.has('g')&&typeof feedList!=='undefined'&&Array.isArray(feedList)&&feedList.length) ready=true;
    if(!ready) return;
    if(!since) since=Date.now();
    else if(Date.now()-since>=2300){ rmBootOff(); clearInterval(iv); }
  },100);
}

// Accès pour le banc et les lots suivants
window.RSM={enter:rmEnter,exit:rmExit,quit:rmQuit,apply:rmApply,fit:rmFit,sync:rmSync,stageVars:rmStageVars,suffixIds:rmSuffixIds,on:rmOn,wanted:rmWanted,sentinel:()=>rmSentinel,
  renderRail:rmRenderRail,railKey:()=>rmRailKey,rails:RM_RAILS,centerActive:rmCenterActive,syncBar:rmSyncBar,openSheet:rmOpenSheet,closeSheet:rmCloseSheet,beforeSizeChange:rmBeforeSizeChange,autoGenSnap:()=>rmAutoGenSnap,
  gammes:rmGammesGet,recolor:rmRecolor,relaunch:rmRelaunch,setBorderCount:rmSetBorderCount,kbOn:rmKbOn,kbOff:rmKbOff,
  openPicker:rmOpenPicker,closePicker:rmClosePicker,pick:()=>rmPick,pickSelect:rmPickSelect,pickRender:rmPickRender,buildMore:rmBuildMore,ar:rmAr,copyLink:rmCopyLink};

// Le parcours peut déjà être ouvert (lien profond résolu avant le chargement du module)
rmApply();
rmBootWatch();
})();
